<div *ngIf="icpScore !== null" id="icp-score-header" class="rounded-xl p-2 2xl:p-3 h-full w-full"
                               [ngClass]="{
                                      'bg-icp-low/5': icpScore <= 35,
                                      'bg-icp-medium/5': icpScore > 35 && icpScore <= 65,
                                      'bg-icp-high/5': icpScore > 65
                                    }">
  <div  class="flex justify-start items-center min-h-[3rem]">

    <div class="shadow-icp-low/25"></div>
    <div class="shadow-icp-medium/25"></div>
    <div class="!shadow-icp-high/25"></div>

    <div class="flex shrink-0 justify-center items-center rounded-lg text-center h-12 w-12 2xl:w-20 !shadow-md"
         [ngClass]="{
            'bg-icp-low !shadow-icp-low/25': icpScore <= 35,
            'bg-icp-medium !shadow-icp-medium/25': icpScore > 35 && icpScore <= 65,
            'bg-icp-high !shadow-icp-high/25': icpScore > 65
          }">
      <span class="flex justify-center items-center text-lg font-semibold text-white tracking-wide h-full w-full cursor-default">{{ icpScore }}</span>
    </div>

    <div class="w-full min-w-0 pl-2 2xl:pl-3">
      <p class="mx-auto text-sm text-secondary dark:text-white font-semibold w-full">ICP Score</p>
      <button class="text-sm tracking-wide mt-1" [ngClass]="{
            'text-icp-low': icpScore <= 35,
            'text-icp-medium': icpScore > 35 && icpScore <= 65,
            'text-icp-high': icpScore > 65
          }" (click)="openIcpScore()">Refine</button>
    </div>

  </div>
</div>

<!-- ICP being computed for the selected company (no score yet) - keep the
     component visible with a loading state instead of hiding it. -->
<div *ngIf="icpScore === null" id="icp-score-header"
     class="rounded-xl p-2 2xl:p-3 h-full w-full bg-violet-50/50 dark:bg-secondary-800">
  <div class="flex justify-start items-center min-h-[3rem]">

    <div class="flex shrink-0 justify-center items-center rounded-lg text-center h-12 w-12 2xl:w-20 !shadow-md bg-gray-300 dark:bg-secondary-700 animate-pulse"></div>

    <div class="w-full min-w-0 pl-2 2xl:pl-3">
      <p class="mx-auto text-sm text-secondary dark:text-white font-semibold w-full">ICP Score</p>
      <p class="text-sm tracking-wide mt-1 text-gray-400 dark:text-gray-400">Calculating...</p>
    </div>

  </div>
</div>
